export const NAVIGATION_STEP = "NAVIGATION_STEP";

// Return an action to update the steps metadata
const updateNavStep = newStepsMeta => {
  return {
    type: NAVIGATION_STEP,
    newStepsMeta
  };
};

export { updateNavStep };



// WEBPACK FOOTER //
// ./src/workerhome/components/Sidebar/actions.js